export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || 'client_id_';
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET || 'client_secret_';
export const GA_TAG = process.env.REACT_APP_GA_TAG || '';
export const GA_TESTING = process.env.REACT_APP_GA_TESTING === 'true' || false;
